import React from "react";

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

/** Last-resort boundary so a render crash shows a reload prompt instead of a blank page. */
class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error("Unhandled UI error", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div role="alert" className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center">
        <p className="text-lg font-semibold">Something went wrong.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="px-4 py-2 rounded-xl border"
        >
          Reload
        </button>
      </div>
    );
  }
}

export default AppErrorBoundary;
